import React, { useState } from "react";
import ProgressBar from "./ProgressBar";
import "../../styles/fonts.css";
const UploadForm = (props) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);

  const videoTypes = ["video/mp4", "video/mkv"];
  const notesTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  const handleChange = (e) => {
    let selected = e.target.files[0];
    if (selected && videoTypes.includes(selected.type)) {
      props.setType("videos");
      setFile(selected);
      setError(`Uploaded ${selected.name} Successfully`);
    } else if (selected && notesTypes.includes(selected.type)) {
      props.setType("notes");
      props.setResourceType(selected.name.split(".")[1]);
      setFile(selected);
      setError(`Uploaded ${selected.name} Successfully`);
    } else {
      setFile(null);
      setError("Please select an valid file ");
    }
  };

  return (
    <form className='text-center m-4 simplefont'>
      <label className='btn btn-dark'>
        <i className='fa fa-upload'></i> Choose Resource to Upload{" "}
        <input type='file' hidden onChange={handleChange} />
      </label>
      <div className='output'>
        {error && !file && <div className='error'>{error}</div>}
        {file && <div>{file.name}</div>}
        {file && (
          <ProgressBar file={file} setFile={setFile} setUrl={props.setUrl} />
        )}
      </div>
    </form>
  );
};

export default UploadForm;
